import { render, staticRenderFns } from "./IcoCubeX.vue?vue&type=template&id=2ae91b90"
import script from "./IcoCubeX.vue?vue&type=script&lang=js"
export * from "./IcoCubeX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports